module.exports = __webpack_public_path__ + "static/media/26.54003389.png";